import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ClickAnalyticsPlugin } from "@microsoft/applicationinsights-clickanalytics-js";
import { createBrowserHistory } from "history";
import { appConfig } from "../services/configService";

const browserHistory = createBrowserHistory();
export const reactPlugin = new ReactPlugin();
export const clickAnalyticsPlugin = new ClickAnalyticsPlugin();

const clickPluginConfig = {
  autoCapture: true,
  useDefaultContentNameOrId: true,
};

export const setUpAppInsights = () => {
  const { appInsightsConnnectionString } = appConfig;
  if (appInsightsConnnectionString) {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: appInsightsConnnectionString,
        /* ...Other Configuration Options... */
        extensions: [reactPlugin, clickAnalyticsPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
          [clickAnalyticsPlugin.identifier]: clickPluginConfig,
        },
        disableAjaxTracking: true,
        disableFetchTracking: true,
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
};
